import { Link } from "react-router-dom";

// Wordmark tipográfico de la marca (evita el logo portrait con mucho fondo blanco)
export const Wordmark = ({ className = "", onClick, tone = "plum", testId }) => {
  const color = tone === "ivory" ? "text-ivory" : "text-plum";
  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid={testId}
      className={`group inline-flex flex-col leading-none ${color} ${className}`}
    >
      <span className="flex items-baseline gap-1.5">
        <span className="font-serif italic text-3xl md:text-[2rem] font-medium">Lu</span>
        <span className="font-serif text-2xl md:text-[1.7rem] tracking-[0.25em] uppercase font-light">
          Design
        </span>
      </span>
      <span
        className={`mt-1 text-[0.55rem] md:text-[0.6rem] tracking-[0.3em] uppercase font-sans font-light ${
          tone === "ivory" ? "text-ivory/60" : "text-rosegold"
        }`}
      >
        Diseño que conecta e inspira
      </span>
    </Link>
  );
};

export default Wordmark;
